module.exports = __webpack_public_path__ + "static/media/alastair-main.c38437e9.png";